import { FC, useEffect, useState } from 'react'
import { Link, Outlet, useParams, useLocation } from 'react-router-dom'

import { useLocale } from 'languages/use-locale'
import { useMediaQuery } from 'hooks/useMediaQuery'
import {
  MenuMask,
  MenuContainer,
  MenuSection,
  MenuItem,
  MenuGradient,
} from './styled'

type Props = {
  menuActive: boolean
  closeMenu: () => void
  onToggle: (value: boolean) => void
}

const Menu: FC<Props> = ({ menuActive, onToggle, closeMenu }) => {
  const { categories, programs } = useLocale()
  const { id } = useParams()
  const location = useLocation()
  const isMobile = useMediaQuery(['(max-width: 1024px)'], [true], false)

  const [topGradient, setTopGradient] = useState(false)
  const [bottomGradient, setBottomGradient] = useState(true)

  const scrollHandler = (event: React.UIEvent<HTMLDivElement>) => {
    const containerHeight = event.currentTarget.clientHeight
    const scrollHeight = event.currentTarget.scrollHeight
    const scrollTop = event.currentTarget.scrollTop

    if (scrollTop === 0) {
      setTopGradient(false)
    } else {
      setTopGradient(true)
    }

    if (scrollHeight - containerHeight - scrollTop < 5) {
      setBottomGradient(false)
    } else {
      setBottomGradient(true)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1023) {
        onToggle(true)
      } else {
        onToggle(false)
      }
    }

    if (location.pathname.startsWith('/about')) {
      // About pages
      window.addEventListener('resize', handleResize)
      handleResize()
    } else if (id) {
      // Program
      if (isMobile) {
        onToggle(false)
        document.body.classList.remove('body_noscroll')
        document.querySelector('html')?.classList.remove('body_noscroll')
      } else {
        onToggle(true)
        document.body.classList.add('body_noscroll')
        document.querySelector('html')?.classList.add('body_noscroll')
      }
    } else if (location.pathname === '/') {
      // Home
      onToggle(false)
      document.body.classList.remove('body_noscroll')
      document.getElementsByTagName('html')[0].classList.remove('body_noscroll')
    }

    return () => window.removeEventListener('resize', handleResize)
  }, [location.pathname])

  useEffect(() => {
    if (id) {
      const menuItem = document.querySelector(`#program${id}`)

      if (menuItem) {
        menuItem.scrollIntoView({ block: 'center' })
      }
    }
  }, [id])

  return (
    <>
      <MenuMask isActive={menuActive}>
        <MenuContainer
          onScroll={scrollHandler}
          isActive={menuActive}
          onClick={
            window.innerWidth > 1024 && location.pathname !== '/'
              ? () => null
              : closeMenu
          }
        >
          <div>
            {/*<div>
              {texts.about.map((about) => (
                <AboutItem
                  key={about.id}
                  isActive={
                    about.id === location.pathname.replace('/about/', '')
                  }
                >
                  <Link to={`/about/${about.id}`}>{about.title}</Link>
                </AboutItem>
              ))}
            </div>*/}

            {categories.map((category) => (
              <MenuSection key={category.id} style={{ color: category.color }}>
                {category.name}
                <ul>
                  {programs
                    .filter((p) => p.category?.id === category.id)
                    .map((program) => (
                      <MenuItem
                        id={'program' + program.id.toString()}
                        key={program.id}
                        isActive={program.id == Number(id)}
                      >
                        <Link to={`/program/${program.id}`}>
                          {program.title}
                        </Link>
                      </MenuItem>
                    ))}
                </ul>
              </MenuSection>
            ))}
          </div>
        </MenuContainer>
        <MenuGradient
          className="top_gradient"
          isActive={menuActive}
          isVisible={topGradient}
        ></MenuGradient>
        <MenuGradient
          className="bottom_gradient"
          isActive={menuActive}
          isVisible={bottomGradient}
        ></MenuGradient>
      </MenuMask>
      <Outlet />
    </>
  )
}
export default Menu
